import { createSelector } from 'reselect';
import assembleChannels from './populateChannels';

const totalUnreadMessages = channels =>
  Math.max(
    0,
    Object.values(channels)
      .filter(c => !c.isDeleted && (c.isDirect || c.isMember))
      .reduce((t, c) => t + Math.max(0, c.messagesUnreadCount || 0), 0),
  );

export default createSelector(state => assembleChannels(state), totalUnreadMessages);
